import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';

import { useRequiredContext } from '../common/hooks-util';
import { AuthContext } from '../contexts/auth-context';
import { useCompany } from '../contexts/company-context';

export const CompanySelectionDialog: React.FC = () => {
  const { needsCompanySelection, availableCompanyKeys, selectCompanyKey } =
    useCompany();
  const { logout } = useRequiredContext(AuthContext);
  const history = useHistory();

  if (!needsCompanySelection) {
    return null;
  }

  return (
    <Dialog
      open={needsCompanySelection}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>Välj aktivt företag</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Du har flera företag kopplade till ditt konto. Välj vilket företag du
          vill arbeta med.
        </DialogContentText>
        <List>
          {availableCompanyKeys?.map((companyKey) => (
            <React.Fragment key={companyKey}>
              <ListItem
                button
                onClick={() => {
                  selectCompanyKey(companyKey);
                  history.push('/');
                }}
              >
                <ListItemText primary={companyKey} />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={logout} color='secondary'>
          Logga ut
        </Button>
      </DialogActions>
    </Dialog>
  );
};
